/*
  Atelierul de Așternuturi — Romanian money format for the bundle widget.

  Shrine's bundle script rebuilds its prices as `currencySymbol + amount.toFixed(2)`,
  which renders "Lei339.00". It never reads the shop's money format, so the moment a
  shopper picks a different variant the totals stop matching every other price on the
  page. Rewriting the minified vendor bundle would be brittle, so instead we watch the
  bundle container and restate whatever it wrote in the shop's own format:
  "339,00 lei". Our own text no longer matches the pattern, so the observer settles
  after one pass instead of looping.
*/
(function () {
  var SELECTOR = '.bundle-offer-container';

  function romanian(value) {
    var parts = value.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return whole + ',' + parts[1] + ' lei';
  }

  function restate(node, symbol) {
    var text = node.textContent.trim();
    if (!text) return;
    // Only touch the vendor's own output: "Lei1,234.00" — never our formatted text.
    var pattern = new RegExp('^' + symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*([\\d,]+)\\.(\\d{2})$', 'i');
    var match = text.match(pattern);
    if (!match) return;
    var amount = parseFloat(match[1].replace(/,/g, '') + '.' + match[2]);
    if (isNaN(amount)) return;
    node.textContent = romanian(amount);
  }

  function sweep(container) {
    var symbol = container.dataset.currencySymbol;
    if (!symbol) return;
    container.querySelectorAll('.price, .regular-price, .compare-price').forEach(function (node) {
      restate(node, symbol);
    });
  }

  function watch(container) {
    sweep(container);
    new MutationObserver(function () {
      sweep(container);
    }).observe(container, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
